<script>
import {
  CdrText, CdrLink,
} from '@rei/cedar';
import { AllHtmlEntities } from 'html-entities';
import metrics from '../../mixins/metrics';

export default {
  name: 'StoreAboutReiComponent',
  components: {
    CdrText,
    CdrLink,
  },
  mixins: [metrics],
  props: {
    aboutModel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    aboutText() {
      const entities = new AllHtmlEntities();
      return entities.decode(this.aboutModel.description);
    },
  },
};
</script>

<template>
  <div class="store-about">
    <cdr-text
      class="store-about__title"
      data-ui="store-about-title"
      tag="h2"
    >
      {{ aboutModel.title }}
    </cdr-text>
    <div
      id="aboutText"
      data-ui="store-about-text"
      class="store-about__text about-text"
      v-html="aboutText"
    />
    <cdr-text
      class="store-about__detail"
      tag="h3"
    >
      Want to work at this location?
    </cdr-text>
    <cdr-link
      id="job-opportunities"
      :href="aboutModel.searchJobLink"
      data-ui="jobs-link"
      class="store-about__link"
      @click="metricsClick('Job opportunities')"
    >
      Job opportunities
    </cdr-link>
  </div>
</template>